<template>
	<div class="container">
		<div class="sec-maker-header text-center">
			<h3 class="sec-maker-h3">Similar Products</h3>
		</div>
		<div class="row w-100" v-if="loading">
			<div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="i in 4" :key="i">
				<div class="item">
					<content-loader
						viewBox="0 0 400 500"
						:speed="2"
						primaryColor="#f3f3f3"
						secondaryColor="#ecebeb"
					>
						<rect x="0" y="0" rx="0" ry="0" width="400" height="292" />
						<rect x="20" y="325" rx="0" ry="0" width="85" height="13" />
						<rect x="20" y="349" rx="0" ry="0" width="297" height="19" />
						<rect x="20" y="379" rx="0" ry="0" width="293" height="31" />
						<rect x="20" y="427" rx="0" ry="0" width="73" height="40" />
					</content-loader>
				</div>
			</div>
		</div>
		<div class="row" v-if="!loading">
			<Product
				:product="product"
				v-for="product in similarProducts.slice(0, 4)"
				:key="product.id"
			/>
		</div>
	</div>
</template>

<script>
	import {publicPath} from "../../../../../vue.config";
	import {mapGetters, mapActions} from "vuex";
	import StarRating from "vue-star-rating";
	import axios from "axios";
	import {formatCurrency} from "../../../../utils/common_functions";
	import {ContentLoader} from "vue-content-loader";
	import Product from "../Product";
	export default {
		components: {StarRating, ContentLoader, Product},
		computed: {...mapGetters("products", ["selectedProduct"])},
		data() {
			return {
				API_URL: process.env.VUE_APP_API_URL,
				publicPath: publicPath,
				similarProducts: [],
				loading: true,
			};
		},
		methods: {
			formatCurrency,
			async fetchSimilarProducts(id) {
				let url = process.env.VUE_APP_API_URL + "/api/similar-products";
				let LocalLatLng = JSON.parse(localStorage.getItem("location"));
				let token = localStorage.getItem("token");
				if (LocalLatLng) {
					url = url + `?latitude=${LocalLatLng.lat}&longitude=${LocalLatLng.lng}`;
				}
				try {
					let {data} = await axios.post(
						url,
						{category_id: id},
						{
							headers: {
								Authorization: `Bearer ${token}`,
							},
						}
					);
					console.log("Similar Products", data.payload);
					this.similarProducts = data.payload;
					this.loading = false;
				} catch (error) {
					console.log(error);
					this.loading = false;
				}
			},
		},

		mounted() {
			this.fetchSimilarProducts(this.selectedProduct.category_id);
		},
	};
</script>

<style></style>
